module.exports = __webpack_public_path__ + "fonts/baronsans-thinitalic-webfont.f54b8d15.woff";